export default __webpack_public_path__ + "static/media/circle-checked.327f21d3.svg";